<template>
    <div class="bookCon">
        <div class="left">
            <ul>
                <template v-for="(item, index) in tab">
                    <li :class="tabAct == item.path ? 'act' : ''" :key="index" v-show="admin || item.name != '重置密码'"  @click="goPage(item)">
                        <div></div>
                        <p>{{ item.name }}</p>
                    </li>
                </template>
            </ul>
        </div>
        <div class="right">
            <div class="banner"></div>
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            admin: JSON.parse(sessionStorage.getItem("admin")),
            tab: [
                {
                    "name": "收听历史",
                    "path": "listenHistory"
                },
                {
                    "name": "我的收藏",
                    "path": "collected"
                },
                {
                    "name": "个人中心",
                    "path": "audienceInfo"
                },
                {
                    "name": "重置密码",
                    "path": "resetUser"
                },
                {
                    "name": "退出登录",
                    "path": "logout"
                },
            ],
            tabAct: "listenHistory",
        }
    },
    computed: {
        routerName() {
            return this.$route.name;
        }
    },
    mounted() {
        let that = this;
        that.tabAct = that.routerName;
    },
    methods: {
        goPage(item) {
            let that = this;
            that.tabAct = item.path;
            that.$router.push(item.path);
        },
    },
    watch: {
        routerName(newV) {
            let that = this;
            that.tabAct = newV;
        }
    }
}
</script>
<style lang="scss" scoped>
    .bookCon{
        width: 1200px;
        margin: 0 auto 50px;
        overflow: hidden;
        box-shadow: 0px 1px 6px 2px rgba(144,144,144,0.13);
        border-radius: 17px;
        display: flex;
        min-height: 600px;
        // height: 1084px;
        >.left{
            width: 250px;
            background: #F3F2F2;
            padding-top: 110px;
            >img{
                display: block;
                margin: 0 auto 20px;
                width: 106px;
                height: 106px;
                border-radius: 50%;
            }
            >p{
                font-size: 22px;
                @include dominant_color(#1c1c1c);
                // line-height: 45px;
                margin-bottom: 74px;
                text-align: center;
            }
            >ul{
                >li{
                    height: 70px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    >div{
                        width: 40px;
                        height: 40px;
                        background-position: center;
                        background-repeat: no-repeat;
                        margin-right: 16px;
                    }
                    >p{
                        font-size: 18px;
                        @include dominant_color(#1c1c1c);
                        line-height: 40px;
                    }
                    &:first-child{
                        >div{
                            background-image: url("../assets/imgs/readerCenter/left_icon1.png");
                        }
                    }
                    &:nth-child(2){
                        >div{
                            background-image: url("../assets/imgs/readerCenter/left_icon2.png");
                        }
                    }
                    &:nth-child(3){
                        >div{
                            background-image: url("../assets/imgs/readerCenter/left_icon3.png");
                        }
                    }
                    &:nth-child(4){
                        >div{
                            background-image: url("../assets/imgs/readerCenter/left_icon4.png");
                        }
                    }
                    &:last-child{
                        >div{
                            background-image: url("../assets/imgs/readerCenter/left_icon5.png");
                        }
                    }
                    &.act{
                        background: #fff;
                        >p{
                            color: #1EA9E2;
                        }
                    }
                    &:first-child.act{
                        >div{
                            background-image: url("../assets/imgs/readerCenter/left_icon1_act.png");
                        }
                    }
                    &:nth-child(2).act{
                        >div{
                            background-image: url("../assets/imgs/readerCenter/left_icon2_act.png");
                        }
                    }
                    &:nth-child(3).act{
                        >div{
                            background-image: url("../assets/imgs/readerCenter/left_icon3_act.png");
                        }
                    }
                    &:nth-child(5).act{
                        >div{
                            background-image: url("../assets/imgs/readerCenter/left_icon4_act.png");
                        }
                    }
                    &:last-child.act{
                        >div{
                            background-image: url("../assets/imgs/readerCenter/left_icon5_act.png");
                        }
                    }
                }
            }
        }
        >.right{
            width: 0%;
            flex: 1;
            padding: 48px 30px 0;
            >.banner{
                width: 100%;
                height: 54px;
                background: url('../assets/imgs/readerCenter/bg1.png') center no-repeat / 100% 100%;
                margin-bottom: 40px;
            }
        }
    }
</style>
